import React from 'react';
import './Footer.css'

const Footer = () => {
    return (
        <div className='footer__section'>
          <h4 className='name'>Nomayen Hossain Ohin</h4>
        </div>
    );
};

export default Footer;


